var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"busy":_vm.busy,"fields":_vm.fields,"subscribe":_vm.subscribe}),_vm._v(" "),(_vm.enableAlerts)?_c('Alert',{attrs:{"alert":_vm.newsletterAlert}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }